import { useState } from 'react';
import { D, st } from '../constants';
import SupplyHousePricing from './SupplyHousePricing';
import SupplyHouseCompare from './SupplyHouseCompare';

const TABS = [
  { id: 'import', label: 'Import Invoice' },
  { id: 'compare', label: 'Compare Prices' },
];

export default function SupplyHousePage({ matPrices, setMatPrices, matPriceHistory, setMatPriceHistory, apiSaveMatPrices }) {
  const [tab, setTab] = useState('import');

  return (
    <div>
      <div style={st.h1}>Supply House Prices</div>
      <div style={{ display: 'flex', gap: 2, marginBottom: 20, borderBottom: `1px solid ${D.border}` }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            ...st.btn(tab === t.id ? 'primary' : ''),
            borderRadius: '6px 6px 0 0',
            marginBottom: -1,
            borderBottom: tab === t.id ? `2px solid ${D.accent}` : '2px solid transparent',
          }}>
            {t.label}
          </button>
        ))}
      </div>
      <div style={st.card}>
        {tab === 'import' && (
          <SupplyHousePricing matPrices={matPrices} setMatPrices={setMatPrices}
            matPriceHistory={matPriceHistory} setMatPriceHistory={setMatPriceHistory}
            apiSaveMatPrices={apiSaveMatPrices} />
        )}
        {tab === 'compare' && (
          <SupplyHouseCompare matPriceHistory={matPriceHistory} />
        )}
      </div>
    </div>
  );
}
